import { Dayjs } from 'dayjs'

import { PmsiTypeEnum } from '@/store/modules/settings/types'
import { HospitalizationType } from '@/store/modules/stay/smr/types'

export interface HomeStats {
  countTotalGlobalStay: number
  countTodoGlobalStay: number
  countNewCodingTotalStay: number
  countTodoNewCodingTotalStay: number
  countDoneNewCodingTotalStay: number
  countTotalOptimizableStay: number
  countOptimizableStay: number
  countTodoOptimizableStay: number
  countTodoDasRevaluableStay: number
  countTodoDasIaRevaluableStay: number
  countTodoDpIaRevaluableStay: number
  countTotalQualityStay: number
  countTodoQualityStay: number
  countTodoNewCodingQualityStay: number
  countTodoDialysisStay: number
}

export const EMPTY_HOME_STATS: HomeStats = {
  countTotalGlobalStay:          0,
  countTodoGlobalStay:           0,
  countNewCodingTotalStay:       0,
  countTodoNewCodingTotalStay:   0,
  countDoneNewCodingTotalStay:   0,
  countTotalOptimizableStay:     0,
  countOptimizableStay:          0,
  countTodoOptimizableStay:      0,
  countTodoDasRevaluableStay:    0,
  countTodoDasIaRevaluableStay:  0,
  countTodoDpIaRevaluableStay:   0,
  countTotalQualityStay:         0,
  countTodoQualityStay:          0,
  countTodoNewCodingQualityStay: 0,
  countTodoDialysisStay:         0,
}

export interface HomeChartStat {
  year: number
  month: number
  week: number
  day: number
  countTotalStay: number
  countTodoStay: number
  countValidatedStay: number
}

export enum PredictionModelType {
  CLASSIFICATION = 'classification',
  GENERATIVE = 'generative',
  AGENT = 'agent',
}

export interface PredictionModel {
  name: string
  type: PredictionModelType
  version: string
  trainedAt: Dayjs | null
}

export interface HomeStatsPayload {
  earlyLimit: Dayjs
  lateLimit: Dayjs
  medicalUnitIds: number[] | null
  pmsiType: PmsiTypeEnum
  hospitalizationTypes: HospitalizationType[]
}

export interface HomeChartStatsPayload {
  mode: string
  unit: string
  earlyLimit: Dayjs
  lateLimit: Dayjs
  medicalUnitIds: number[] | null
}
